import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';

const dataProviderName = 'campaigns/campaign';
const wizardAction = 'statuschange'

const ReassignmentReject = ({ selected, setSelected }) => {
    const { t } = useTranslation();
    const { doAction } = useDataProvider(dataProviderName);


    const handleStatusChange = () => {
        doAction({ 
            action: wizardAction, 
            model: dataProviderName, 
            data: {selected:selected, status:'rejected'} 
        }).then(() => setSelected([]));
    };

    return [
        <>
            <Button
                onClick={handleStatusChange}
                label={t("Rifiuta (" + selected.length + ")")}
                icon="faThumbsDown"
                family="fas"
                variant="solid"
                size="small"
                className="button-select"
            />
        </>
    ];
};

export default ReassignmentReject;
